import { memo } from 'react';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Event } from '@/feature/event-details-sbk/types';

import { SbkEventDetailsSheetHandle } from './SbkEventDetailsSheetHandle';
import { SbkEventSheetContent } from './SbkEventSheetContent';

type SbkEventDetailsScreenProps = {
    isActive: boolean;
    event: Event;
};

export const SbkEventDetailsScreen = memo(({ isActive, event }: SbkEventDetailsScreenProps) => {
    return (
        <Box flex={1} minHeight={'100%'} backgroundColor={ds.colorToken.background.neutral.base}>
            <SbkEventDetailsSheetHandle event={event} />
            <SbkEventSheetContent eventId={event.id} isActive={isActive} />
        </Box>
    );
});
